import { render, staticRenderFns } from "./Carrosell.vue?vue&type=template&id=b75c16b2"
import script from "./Carrosell.vue?vue&type=script&lang=js"
export * from "./Carrosell.vue?vue&type=script&lang=js"
import style0 from "./Carrosell.vue?vue&type=style&index=0&id=b75c16b2&prod&lang=css"


/* normalize component */
import normalizer from "!../go/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports